import React from 'react';
import { connect } from 'react-redux';

import Menu from 'controls/menu/Menu';
import TrackTemplateEditToolbar from 'controls/track-template-edit-toolbar/TrackTemplateEditToolbar';
import CycloParams from 'controls/cyclo-params/CycloParams';

class TrackTemplateCreate extends React.Component {
  render () {
    return (
      <div>
        <Menu/>
        <TrackTemplateEditToolbar
          trackId={ this.props.trackId }
        />
        <CycloParams
          trackId={ this.props.trackId }
          colorPickerEnabled={ false }
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    trackId: ownProps.match.params.trackId
  };
}

export default connect(mapStateToProps, () => { return{} })(TrackTemplateCreate);
